import { useInitialUrlContext } from "../contexts/InitialUrlContext";

export const useInitialUrl = () => useInitialUrlContext();
